import Head from "../components/Head/Head"
import React from "react"
import Header from "../components/Header"
import ContentMainPage from "../content/ContentMainPage"


export default (
  {
    pageContext,
  }
) =>{
  console.log('pageContext: ', pageContext)
  return (<>
    <Head
      Description={pageContext.text}
      logo={pageContext.imageMeta}
      slug={pageContext.slug}
    />
    <Header />
    <ContentMainPage />

  </>)

};
